
import {
    FETCH_INIT,
    FETCHED,
    FETCHED_FAIL,
    SET_FILTER,
    SET_SORTING,
    CHANGE_PAGE,
    SET_SERVER_PAGE,
    SET_ROW_SIZE,
    RESET_FILTER,
    CLEAN,
    RESET_TABLE_DATA,
} from "../actions/DietitianConsultationHistory.action";

function mapPresetPRequest(all, pageId, rowsPerPage) {
    return all.filter((_val, index) => {
        const start = (pageId + 1) * rowsPerPage - rowsPerPage;
        const end = (pageId + 1) * rowsPerPage;
        return index >= start && index < end;
    });
}

const INITIAL_STATE = {
    all: [],
    present: [],
    query: null,
    query_data: null,
    sorting_data: { row: null, order: null },
    is_fetching: false,
    currentPage: 0,
    serverPage: 0,
    rowsPerPage: 10,
    resetCounter: 0,
    filter: {},
};

export default function (state = JSON.parse(JSON.stringify(INITIAL_STATE)), action) {
    switch (action.type) {
        case FETCH_INIT: {
            return { ...state, is_fetching: true };
        }
        case FETCHED: {
            const responseData = action.payload?.data || action.payload || {};
            const newData = responseData?.response_obj?.list || responseData?.list || [];
            const page = action.payload?.page || 0;

            // Only replace data if page is 0, otherwise append
            const newAll = page === 0 ? [...newData] : [...state.all, ...newData];
            const present = mapPresetPRequest(newAll, state.currentPage, state.rowsPerPage);

            return {
                ...state,
                all: newAll,
                present,
                is_fetching: false,
                serverPage: page
            };
        }
        case FETCHED_FAIL: {
            return { ...state, all: [], present: [], is_fetching: false };
        }
        case SET_FILTER: {
            return {
                ...state,
                query: action.payload?.query,
                query_data: action.payload?.query_data,
                filter: action.payload,
            };
        }
        case SET_SORTING: {
            return { ...state, sorting_data: action.payload };
        }
        case CHANGE_PAGE: {
            const present = mapPresetPRequest(state.all, action.payload, state.rowsPerPage);
            return { ...state, present, currentPage: action.payload };
        }
        case SET_SERVER_PAGE: {
            return { ...state, serverPage: action.payload };
        }
        case SET_ROW_SIZE: {
            const present = mapPresetPRequest(state.all, 0, action.payload);
            return { ...state, rowsPerPage: action.payload, present, currentPage: 0 };
        }
        case RESET_FILTER: {
            return {
                ...JSON.parse(JSON.stringify(INITIAL_STATE)),
                resetCounter: state.resetCounter + 1,
            };
        }
        case CLEAN: {
            return JSON.parse(JSON.stringify(INITIAL_STATE));
        }
        case RESET_TABLE_DATA: {
            return {
                ...state,
                all: [],
                present: [],
                currentPage: 0,
                serverPage: 0
            };
        }
        default: {
            return state;
        }
    }
}